module.exports = __webpack_public_path__ + "img/close-icon.298de350.svg";